import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { startFlito, identify, reset } from 'src/utils/flito';

/** Loads the FlitoCRM tracker and keeps it told who is signed in. */
function FlitoTracking() {
  const user = useSelector((state) => state.account.user);
  const lastEmail = useRef(null);

  useEffect(() => {
    startFlito();
  }, []);

  useEffect(() => {
    const email = user && user.email ? user.email : null;
    if (email && email !== lastEmail.current) identify(user);
    if (!email && lastEmail.current) reset();
    lastEmail.current = email;
  }, [user]);

  return null;
}

export default FlitoTracking;
